import { get } from "../../../helpers/axios"


const BASE_PATH = "/rates"

export const getWebRates = () =>
  get(`${BASE_PATH}/web`)
